export const EXTERNAL_TICKET_SUPPORT_SUBJECTS = {
  DEFAULT_LANGUAGE: 'Default language selection',
  TRANSLATION_FINISHED: 'Can’t see the translations'
}